const initState= {
    project: {
        playground: {
            code: "empty"
        }
    }
};

const projectReducer = (state = initState, action) => {
    switch(action.type) {
        case "PLAYGROUND_CODE_UPDATE":
            console.log("Playground code updated", action.data);
            return state;
        case "PLAYGROUND_CODE_UPDATE_ERROR":
            console.log("Playground code updating error", action.data);
            return state;
        default:
            return state;
    }
};

export default projectReducer;